import {httpGet, httpPost, httpDownload} from '@/util/request.js';
import appConfig from "@/config";

export default class grouponApi {

    // static baseUrl = "http://10.254.121.61:10068" + appConfig.smMarketManageServicePath;
    static baseUrl = appConfig.gatewayUrl + appConfig.smMarketManageServicePath;
    
    static getGroupBuyInfo(param){
        return httpPost(this.baseUrl + "/sendCoupon/getGroupBuyInfo", param);
    }

    static getList(param){
        return httpPost(this.baseUrl + "/sendCoupon/getList", param);
    }


    // 获取详情
    static getDetail(id) {
        return httpGet(this.baseUrl + "/sendCoupon/getRecordById?id=" + id);
    }

    // 打印记录
    static printRecord(id) {
        return httpGet(this.baseUrl + "/sendCoupon/print?id=" + id);
    }


    // 打印记录列表
    static printRecordList(id) {
        return httpGet(this.baseUrl + "/sendCoupon/printInfo?id=" + id);
    }

    // 新增
    static addRecord(param){
        return httpPost(this.baseUrl + "/sendCoupon/addRecord", param);
    }

    /**
     * 获取券规则
     */
    static getRule(param) {
        return httpPost(this.baseUrl + '/sendCoupon/getRule', param)
    }

    /**
     * 审批
     * @param recordId
     * @returns {*}
     */
    static auditRecord(param) {
        return httpPost(this.baseUrl + '/sendCoupon/audit', param)
    }


    /**
     * 作废单审批
     * @param recordId
     * @returns {*}
     */
    static auditCancelRecord(param) {
        return httpPost(this.baseUrl + '/voidCoupon/audit', param)
    }


    /**
     * 激活
     * @param recordId
     * @returns {*}
     */
    static activeRecord(recordId) {
        return httpGet(this.baseUrl + '/sendCoupon/activeCouponCode?id=' + recordId)
    }

    // 导出赠券明细
    static exportDetailList(recordId) {
        return httpDownload(this.baseUrl + '/sendCoupon/exportData?id=' + recordId)
    }


    /**
     * 获取赠券单列表
     * @returns {*}
     */
    static getSendList(param) {
        return httpPost(this.baseUrl + '/sendCoupon/getSendList', param)
    }

    /**
     * 获取赠券列表
     * @returns {*}
     */
    static getCouponInfo(param) {
        return httpGet(this.baseUrl + '/sendCoupon/getCouponInfo?id=' + param.recordId + '&pageNo=' + param.pageNo + '&pageSize=' + param.pageSize)
    }

    /**
     * 获取赠券列表
     * @returns {*}
     */
    static getCouponInfoNoPage(param) {
        return httpGet(this.baseUrl + '/sendCoupon/getCouponInfoNoPage?id=' + param.recordId + '&num=' + param.number)
    }

    // 获取作废单列表
    static getVoidList(param) {
        return httpPost(this.baseUrl + "/voidCoupon/getVoidList", param);
    }

    // 获取作废单详情
    static getCancelDetail(id) {
        return httpGet(this.baseUrl + "/sendCoupon/getRecordById?id=" + id);
    }


    /**
     * 提交作废单
     * @returns {*}
     */
    static addCancelRecord(params) {
        return httpPost(this.baseUrl + '/voidCoupon/addRecord', params)
    }

    /**
     * 作废单审核
     * @returns {*}
     */
    static auditCancelRecord(param) {
        return httpPost(this.baseUrl + '/voidCoupon/audit', param)
    }

    /**
     * 获取作废单详情
     * @param recordId
     * @returns {*}
     */
    static getCancelDetailById(recordId) {
        return httpGet(this.baseUrl + '/voidCoupon/getListById?id=' + recordId)
    }



    static httpRequest(url, param, method ){
        if(method == 'get'){
            return httpGet(this.baseUrl + url, param);

        }
        if(method == 'post'){
            return httpPost(this.baseUrl + url, param);
        }
    }

    static handleResponse(response, scope, successFunc,errorFunc){
        let data = response.data;
        if(data.code == 200){
            if(successFunc && typeof successFunc == 'function'){
                successFunc(data.data);
            }
        }else{
            let text = data.errMsg
            scope.$dialog.error({
                text: text,
                title: "错误"
            });
            if(errorFunc && typeof errorFunc == 'function'){
                errorFunc(data);
            }
        }
    }

    static handleNetworkError(response, scope, errorFunc){
        scope.$dialog.error({
            text: response.message,
            title: "错误"
        });
        if(errorFunc && typeof errorFunc == 'function'){
            errorFunc(response);
        }
    }
}